import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/", label: "Start", testId: "nav-link-start" },
  { to: "/ueber-uns", label: "Über uns", testId: "nav-link-ueber-uns" },
  { to: "/portfolio", label: "Suchprofil", testId: "nav-link-portfolio" },
  { to: "/partner", label: "Partner", testId: "nav-link-partner" },
  { to: "/referenzen", label: "Portfolio", testId: "nav-link-referenzen" },
  { to: "/kontakt", label: "Kontakt", testId: "nav-link-kontakt" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background/85 backdrop-blur-xl border-b border-border"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
            <img
              src="/assets/keppel-logo.png"
              alt="Keppel Immobilien"
              className="h-12 md:h-14 w-auto"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={n.testId}
                className={({ isActive }) =>
                  `text-sm tracking-wide transition-colors duration-200 ${
                    isActive
                      ? "text-primary"
                      : "text-foreground/80 hover:text-primary"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:block">
            <Link to="/verkaufen" data-testid="nav-cta-verkaufen">
              <Button className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 px-6 h-11">
                Haus verkaufen
              </Button>
            </Link>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 -mr-2 text-foreground"
            data-testid="mobile-menu-toggle"
            aria-label="Menü"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-background" data-testid="mobile-menu">
          <div className="px-6 py-6 space-y-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={closeMenu}
                className={({ isActive }) =>
                  `block text-base ${isActive ? "text-primary" : "text-foreground"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/verkaufen" onClick={closeMenu}>
              <Button className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 w-full mt-4 h-11">
                Haus verkaufen
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
